// Dependecies
import { useState, useEffect } from 'react';

// Store
import user from '../../store/user';

function useMap(plate) {
  const [userStore] = user();
  const [markers, useSetCoordinates] = useState([]);
  const [latitud, useSetLatitud] = useState(0);
  const [longitud, useSetLongitud] = useState(0);
  const [activeMarker, useSetActiveMarker] = useState({});
  const [selectedPlace, useSetSelectedPlace] = useState([]);
  const [showingInfoWindow, useSetShowingInfoWindow] = useState(false);

  const getMap = async () => {
    const jsons = {
      licensePlate: plate,
    };
    const options = {
      method: 'POST',
      body: JSON.stringify(jsons),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `bearer ${userStore.token}`,
      },
    };
    const response = await fetch('/api/bread/jwt/services/static/map_dashboard', options);
    const newData = await response.json();

    if (response.status === 200) {
      useSetCoordinates(newData.vehicle);
      if (newData.vehicle.length > 0) {
        useSetLatitud(newData.vehicle[0].lat);
        useSetLongitud(newData.vehicle[0].lng);
      }
    }
  };

  useEffect(() => {
    if (userStore.token) {
      getMap();
    }
  }, [plate]);

  useEffect(() => {
    if (userStore.token) {
      const interval = setInterval(() => {
        getMap();
      }, 60000); /* Milisegundos */
      return () => clearInterval(interval);
    }
    return false;
  }, [userStore.token]);

  const onMarkerClick = (props, marker) => {
    useSetActiveMarker(marker);
    useSetSelectedPlace(props);
    useSetShowingInfoWindow(true);
  };
  const onInfoWindowClose = () => {
    useSetActiveMarker(null);
    useSetShowingInfoWindow(false);
  };

  const onMapClicked = () => {
    if (showingInfoWindow) {
      useSetActiveMarker(null);
      useSetShowingInfoWindow(false);
    }
  };

  return {
    markers,
    useSetCoordinates,
    onMarkerClick,
    onInfoWindowClose,
    onMapClicked,
    latitud,
    longitud,
    activeMarker,
    selectedPlace,
    showingInfoWindow,
    getMap,
  };
}

export default useMap;
